// ============================================================================
// CANCUN100 — notaVenta.js  (APP 2/28 · RP-10: nota de venta insertada en la reserva)
// ----------------------------------------------------------------------------
// En Nueva reserva (no en la cotización) las `productos.nota_venta` de los productos elegidos se insertan solas en una
// sección «Importante» del campo Notas: un renglón por producto («Producto: nota»), sin repetir la misma nota, recalculado
// al agregar o quitar productos. El texto del agente va aparte y no se borra. Al guardar, viaja en reservas.notas con el
// marcador de abajo; al generar el PDF del cliente se separa otra vez (texto del agente → Notas; renglones → Importante).
// nota_venta es opcional: si no existe todavía (Catálogo la crea), no hay sección.
// ============================================================================
export const MARCA_IMPORTANTE = 'Importante:';
const limpia = (s) => String(s || '').replace(/\s+/g, ' ').trim();

// [{ nombre, nota }] a partir de los productos de la reserva (catItems: { product: { nombre, nota_venta } }). Sin repetir la nota.
export const lineasImportante = (catItems = []) => {
  const vistas = new Set(); const out = [];
  catItems.forEach((it) => {
    const p = it?.product || it; const nota = limpia(p?.nota_venta); if (!nota) return;
    const k = nota.toLowerCase(); if (vistas.has(k)) return; vistas.add(k);
    out.push({ nombre: limpia(p?.nombre) || 'Producto', nota });
  });
  return out;
};
export const textoImportante = (lineas = []) => (lineas.length ? `${MARCA_IMPORTANTE}\n${lineas.map((l) => `- ${l.nombre}: ${l.nota}`).join('\n')}` : '');
// Texto del agente + sección Importante, para guardar en reservas.notas.
export const unirNotas = (texto, lineas = []) => { const t = String(texto || '').trim(); const imp = textoImportante(lineas); return [t, imp].filter(Boolean).join('\n\n'); };
// Lo contrario: { texto, importante: [{ nombre, nota }] }. Tolera notas sin marcador (reservas viejas).
export const partirNotas = (notas) => {
  const s = String(notas || ''); const i = s.indexOf(MARCA_IMPORTANTE);
  if (i < 0) return { texto: s.trim(), importante: [] };
  const texto = s.slice(0, i).trim();
  const importante = s.slice(i + MARCA_IMPORTANTE.length).split(/\r?\n/).map((l) => l.replace(/^\s*[-•]\s*/, '').trim()).filter(Boolean).map((l) => { const j = l.indexOf(': '); return j > 0 ? { nombre: l.slice(0, j).trim(), nota: l.slice(j + 2).trim() } : { nombre: '', nota: l }; });
  return { texto, importante };
};
// Solo el texto del agente (para volver a editar una reserva guardada sin duplicar la sección).
export const soloTextoAgente = (notas) => partirNotas(notas).texto;
export const TX_IMPORTANTE = { es: 'IMPORTANTE', en: 'IMPORTANT', pt: 'IMPORTANTE' };
// Sin emoji ni símbolos fuera del rango que la fuente del PDF imprime.
export const sinEmoji = (str) => String(str || '').replace(/[\u{1F300}-\u{1FAFF}]/gu, '').replace(/[\u{2600}-\u{27BF}]/gu, '').replace(/[\u{1F000}-\u{1F2FF}]/gu, '').replace(/[\u{FE00}-\u{FE0F}]/gu, '').replace(/\s+/g, ' ').trim();
